import { useState } from 'react'
import QRCode from 'react-qr-code'

interface QRCodeModalProps {
    email: string
    userName: string
    initialPassword?: string | null
    onClose: () => void
}

export function QRCodeModal({ email, userName, initialPassword, onClose }: QRCodeModalProps) {
    const [password, setPassword] = useState(initialPassword || '')

    // Construct the deep link URL
    const qrValue = `maymagpie-prism://login?u=${encodeURIComponent(email)}&a=${encodeURIComponent(password)}`

    const saveQrCode = () => {
        const svg = document.getElementById("qr-code-svg");
        if (!svg) return;

        const svgData = new XMLSerializer().serializeToString(svg);
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        const img = new Image();

        // Add padding
        const padding = 20;

        img.onload = () => {
            canvas.width = img.width + (padding * 2);
            canvas.height = img.height + (padding * 2);

            if (ctx) {
                // Fill white background
                ctx.fillStyle = "white";
                ctx.fillRect(0, 0, canvas.width, canvas.height);

                // Draw image centered with padding
                ctx.drawImage(img, padding, padding);

                const pngFile = canvas.toDataURL("image/png");
                const downloadLink = document.createElement("a");
                downloadLink.download = `qrcode_${userName}_${new Date().getTime()}.png`;
                downloadLink.href = pngFile;
                downloadLink.click();
            }
        };

        img.src = "data:image/svg+xml;base64," + btoa(svgData);
    };

    return (
        <div className="fixed inset-0 bg-gray-900 bg-opacity-50 flex items-center justify-center z-50 p-4 font-display">
            <div className="bg-white rounded-xl shadow-2xl max-w-md w-full">
                <div className="flex items-center justify-between p-6 border-b border-gray-200">
                    <div className="flex items-center gap-3">
                        <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-gray-100">
                            <span className="material-symbols-outlined text-gray-600">qr_code_2</span>
                        </div>
                        <div>
                            <h2 className="text-xl font-bold text-gray-900">로그인 QR 코드</h2>
                            <p className="text-sm text-gray-500">{userName}</p>
                        </div>
                    </div>
                    <button
                        onClick={onClose}
                        className="text-gray-400 hover:text-gray-600 transition-colors"
                    >
                        <span className="material-symbols-outlined">close</span>
                    </button>
                </div>

                <div className="p-6 space-y-6">
                    <div className="bg-yellow-50 border border-yellow-100 rounded-lg p-3 text-sm text-yellow-800">
                        <div className="flex gap-2">
                            <span className="material-symbols-outlined text-yellow-600">info</span>
                            <p>
                                보안을 위해 비밀번호는 저장되지 않으므로, <br />
                                QR 코드를 생성하려면 <strong>사용자의 비밀번호</strong>를 입력해야 합니다.
                            </p>
                        </div>
                    </div>

                    <div>
                        <label htmlFor="qr-password" className="block text-sm font-medium text-gray-700 mb-2">
                            비밀번호 입력
                        </label>
                        <input
                            id="qr-password"
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="form-input block w-full px-4 py-2.5 border-gray-200 rounded-lg text-gray-900 focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500"
                            placeholder="비밀번호를 입력하세요"
                        />
                    </div>

                    <div className="flex flex-col items-center justify-center p-6 bg-gray-50 rounded-xl border border-gray-100">
                        {password ? (
                            <div className="bg-white p-4 rounded-lg shadow-sm">
                                <QRCode
                                    id="qr-code-svg"
                                    value={qrValue}
                                    size={200}
                                    level="M"
                                />
                            </div>
                        ) : (
                            <div className="h-[200px] w-[200px] flex flex-col items-center justify-center text-gray-300 border-2 border-dashed border-gray-300 rounded-lg">
                                <span className="material-symbols-outlined text-4xl mb-2">lock</span>
                                <span className="text-sm">비밀번호를 입력하면<br />QR코드가 표시됩니다</span>
                            </div>
                        )}

                        {password && (
                            <div className="mt-4 flex flex-col items-center gap-2 w-full">
                                <p className="text-xs text-gray-400 font-mono break-all text-center max-w-xs">
                                    {qrValue}
                                </p>
                                <button
                                    onClick={saveQrCode}
                                    className="flex items-center gap-2 px-4 py-2 bg-indigo-600 text-white text-sm font-medium rounded-lg hover:bg-indigo-700 transition-colors shadow-sm"
                                >
                                    <span className="material-symbols-outlined text-sm">download</span>
                                    <span>QR 다운로드</span>
                                </button>
                            </div>
                        )}
                    </div>
                </div>

                <div className="p-6 border-t border-gray-200 flex justify-end">
                    <button
                        onClick={onClose}
                        className="px-6 py-2.5 bg-gray-900 text-white font-medium rounded-lg hover:bg-gray-800 transition-colors"
                    >
                        닫기
                    </button>
                </div>
            </div>
        </div>
    )
}
